<template>
  <div id="priceCalculator" class="wa sector bg-darker df fr">
    <div class="sector df fc wa">
      <div class="fs30 t-center wa">Оплачиваю</div>
      <div class="wa df fr bg-darker">
        <input type="text" class="wa t-gray" :disabled="disabled" placeholder="100" v-model="rub" @input="updateByRub" />
        <div class="t-green all-center fs30 df">₽</div>
      </div>
    </div>
    <div class="df wh all-center sector">
      <div class="fs30">&lt;=&gt;</div>
    </div>
    <div class="sector df fc wa">
      <div class="fs30 t-center wa">Получаю</div>
      <div class="wa df fr bg-darker">
        <input type="text" class="wa t-gray" :disabled="disabled" :placeholder="100 * rate" v-model="robux" @input="updateByRobux" />
        <div class="t-red all-center fs30 df">R$</div>
      </div>
    </div>
  </div>
</template>

<script>
const strip = s => s.replace(/[^\d.-]/g, '');

export default {
  props: ["disabled", "preamount", "rate"],

  data() {
	return {
	  rub: "",
	  robux: ""
	}
  },

  mounted() {
	if (this.preamount) {
	  this.robux = `${this.preamount}`
	  this.updateByRobux()
    }
  },

  methods: {
	updateByRub() {
	  let rub = parseInt(strip(this.rub))
	  
	  if (isNaN(rub)) {
		this.rub = ""
		this.robux = ""
		return
	  }

	  if (rub > 100000) {
		rub = 100000
	  }
	  this.rub = rub
	  this.robux = Math.round(this.rub * this.rate)

	  this.$emit("amount", this.robux)
	},
	updateByRobux() {
	  let robux = parseInt(strip(this.robux))
	  const rate = this.rate
	  if (isNaN(robux)) {
		this.rub = ""
		this.robux = ""
		return
	  }

	  if (robux > 100000*rate) {
		robux = 100000*rate
	  }
	  this.robux = robux
	  this.rub = Math.round(this.robux / rate)
	  
	  this.$emit("amount", this.robux)
	}
  }
}
</script>
